import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { registerSW } from 'virtual:pwa-register'

// Register service worker for offline functionality
registerSW({
  immediate: true,
  onNeedRefresh() {
    // Auto-update without user prompt for seamless experience
  },
  onOfflineReady() {
    // App ready to work offline
  }
})

async function enableMocking() {
  if (import.meta.env.DEV) {
    const { worker } = await import('./mocks/browser')
    
    // Start the worker with onUnhandledRequest set to bypass for static assets
    return worker.start({
      onUnhandledRequest: 'bypass',
    })
  }
  return Promise.resolve()
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Failed to find the root element')
}

// Enable MSW in development before rendering
void enableMocking().then(() => {
  // Only use StrictMode in development
  const app = import.meta.env.DEV ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
  
  ReactDOM.createRoot(rootElement).render(app)
})